import React from 'react';
import PropTypes from 'prop-types';
import BtnUpdate from '../common/BtnUpdate';
import SelectKikanNew from '../common/SelectKikanNew';
import SelectKubunNew from '../common/SelectKubunNew';
import SelectPSKubun from '../common/SelectPSKubun';
import SelectRate from '../common/SelectRate';
import SelectKaishibiNew from '../common/SelectKaishibiNew';
import SelectTypeNew from '../common/SelectTypeNew';
import SelectMakerNew from '../common/SelectMakerNew';
import SearchKishuName from '../common/SearchKishuName';
import SelectGoukiNew from '../common/SelectGoukiNew';
import SelectGoukiKotei from '../common/SelectGoukiKotei';
import SelectYugiTypeNew from '../common/SelectYugiTypeNew';
import SelectYugiTypeKotei from '../common/SelectYugiTypeKotei';
import * as defaultValue from '../../../constants/common/ConstDefaultValue';
import SelectSmartYugikiNew from '../common/SelectSmartYugikiNew';
import SelectDisplayFormat from '../common/SelectDisplayFormat';
// import SelectGridItemFilterCheckBox from '../common/SelectGridItemFilterCheckBox';
import * as CHECKBOX_CONTENTS from '../../../constants/common/CheckBoxContents';
// import SelectGridItemFilterRadio from '../common/SelectGridItemFilterRadio';
import * as commonLogic from '../../../logic/CommonLogic';

/**
 * FilterForm
 */
class FilterForm extends React.Component {

  // 詳細設定用に追加
  constructor(props) {
    super(props);
    this.state = {
      pskubun: this.props.data.pskubun,
      rate: this.props.data.rate,
      kikanUnit: this.props.data.termUnit,
      radioList: this.getRadioboxList(),
    };
    this.changePSKubun = this.changePSKubun.bind(this);
    this.changeKikanUnit = this.changeKikanUnit.bind(this);
    this.changeCheckbox = this.changeCheckbox.bind(this);
    this.changeRadiobox = this.changeRadiobox.bind(this);
  }

  getRadioboxList() {
    let radioBoxList = this.props.data.displayItemsPachi || CHECKBOX_CONTENTS.RADIO_CONTENTS_PACHI;
    if (this.props.data.pskubun != defaultValue.PS_PACHINKO) {
      radioBoxList = this.props.data.displayItemsSlot || CHECKBOX_CONTENTS.RADIO_CONTENTS_SLOT;
    }

    return radioBoxList;
  }

  /**
   * PS区分変更イベント 
   * @param {*} newRate 
   */
  changePSKubun(newPsKubun, newRate) {
    this.setState({ pskubun: newPsKubun, rate: newRate, radioList: this.getRadioboxList() });
  }

  changeKikanUnit(newKikanUnit) {
    this.setState({ kikanUnit: newKikanUnit });
  }

  changeCheckbox(index) {
    const list = commonLogic.deepCopy(this.state.checkboxList);
    list[index].checked = !list[index].checked;
    // TODO すべて　のパターンを実装

    if (this.props.data.pskubun == defaultValue.PS_PACHINKO) {
      this.props.data.displayItemsPachi[index].checked = !this.props.data.displayItemsPachi[index].checked;
    } else {
      this.props.data.displayItemsSlot[index].checked = !this.props.data.displayItemsSlot[index].checked;
    }

    this.setState({ checkboxList: list });
  }

  changeRadiobox(index) {
    const list = commonLogic.deepCopy(this.state.radioList);
    list.forEach((item) => {
      item.checked = false;
    });
    list[index].checked = !list[index].checked;

    this.setState({ radioList: list });
  }

  render() {
    let selectGouki = '';
    if (this.props.data.pskubun == defaultValue.PS_SLOT) {
      selectGouki = <SelectGoukiNew actions={this.props.actions} data={this.props.data} comactions={this.props.comactions} />;
    } else {
      selectGouki = <SelectGoukiKotei />;
    }

    let selectYugiType = '';
    if (this.props.data.pskubun == defaultValue.PS_PACHINKO) {
      selectYugiType = <SelectYugiTypeNew actions={this.props.actions} data={this.props.data} comactions={this.props.comactions} />;
    } else {
      selectYugiType = <SelectYugiTypeKotei />;
    }


    return (
      <div className="filter_form" id="filter_form">
        <div className="ctrl_form_title2">
          <div className="ctrl_form_title_left">
            絞り込み条件
          </div>
        </div>
        <div id="filter_form_area" className="filter_form_area">
          <div className="filter_form_area_child">
            <div className="ctrl_form_title controlForm__text--state_enable">
              <p>パチンコ・スロット</p>
            </div>
            <SelectPSKubun actions={this.props.actions} data={this.props.data} isReadOnly={false} changePSKubun={this.changePSKubun} />

            <div className="ctrl_form_title controlForm__text--state_enable">
              <p>レート</p>
            </div>
            <SelectRate actions={this.props.actions} data={this.props.data} comactions={this.props.comactions} isReadOnly={false} pskubun={this.state.pskubun} rate={this.state.rate} />

            <SelectKikanNew actions={this.props.actions} data={this.props.data} comactions={this.props.comactions} kikanUnit={this.state.kikanUnit} changeKikanUnit={this.changeKikanUnit} />

            <SelectMakerNew actions={this.props.actions} data={this.props.data} />{/* メーカー */}
            <SelectKubunNew actions={this.props.actions} data={this.props.data} comactions={this.props.comactions} pskubun={this.state.pskubun} /> {/* 地域・区分 */}
            <SelectTypeNew actions={this.props.actions} data={this.props.data} comactions={this.props.comactions} />{/* タイプ */}
            <SelectKaishibiNew actions={this.props.actions} data={this.props.data} comactions={this.props.comactions} />{/* 納品開始日 */}
            <SearchKishuName actions={this.props.actions} data={this.props.data} /> {/* 機種名検索 */}
            {selectGouki}{/* 号機 */}
            {selectYugiType}{/* 遊技タイプ */}
            <SelectSmartYugikiNew actions={this.props.actions} data={this.props.data} /> {/* スマート遊技機 */}
            {/* <SelectDisplayFormat actions={this.props.actions} data={this.props.data} isReadOnly={false} /> */}

            {/* <SelectGridItemFilterCheckBox actions={this.props.actions} label={'表示するデータ'} checkBoxList={this.state.checkboxList} comactions={this.props.comactions} changeCheckbox={this.changeCheckbox} />
            <SelectGridItemFilterRadio actions={this.props.actions} label={'表示する値'} radioList={this.state.radioList} comactions={this.props.comactions} changeRadiobox={this.changeRadiobox} /> */}
          </div>
        </div>

        <div className="ctrl_form_bottom">
          <BtnUpdate actions={this.props.actions} />
        </div>
      </div>

    );
  }
}

FilterForm.propTypes = {
  data: PropTypes.any.isRequired,
  actions: PropTypes.any.isRequired,
  comactions: PropTypes.any.isRequired
};

export default FilterForm;
